import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

const BASE = `${process.env.REACT_APP_API_URL}/design-agent`;

export async function createSession(params?: {
  contact_phone?: string;
}) {
  try {
    return await axios
      .post(`${BASE}/sessions/`, params)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error creating session");
      });
  } catch (error) {}
}

export async function listSessions() {
  try {
    return await axios
      .get(`${BASE}/sessions/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching sessions");
      });
  } catch (error) {}
}

export async function getSession(sessionId: number) {
  try {
    return await axios
      .get(`${BASE}/sessions/${sessionId}/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching session");
      });
  } catch (error) {}
}

export async function sendMessage(
  sessionId: number,
  messageText: string,
  simulateWhatsapp = false,
  forceNewLead = false
) {
  try {
    return await axios
      .post(`${BASE}/sessions/${sessionId}/send-message/`, {
        message: messageText,
        simulate_whatsapp: simulateWhatsapp,
        force_new_lead: forceNewLead,
      })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error sending message");
      });
  } catch (error) {}
}

export async function deleteMyKylasLead(contactPhone?: string) {
  try {
    return await axios
      .post(`${BASE}/kylas/delete-my-lead/`, contactPhone ? { contact_phone: contactPhone } : {})
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error deleting Kylas lead");
      });
  } catch (error) {}
}

export async function closeSession(sessionId: number) {
  try {
    return await axios
      .post(`${BASE}/sessions/${sessionId}/close/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error closing session");
      });
  } catch (error) {}
}
